<template>
  <div>
    <!-- 附加服务赔款 -->
    <el-dialog :title="$t('message.refundModeEditing')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1200px" center>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!--附加服务选择  -->
            <li class="flex15">
              {{ $t("message.additionalServiceOptions") }}
            </li>
            <!--数量  -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!--实际收费标准  -->
            <li class="flex15">{{ $t("message.actualCharges") }}</li>
            <!--已收费用  -->
            <li>{{ $t("message.paidFor") }}(元)</li>
            <!-- 赔款数量 -->
            <li>{{ $t("message.amountOfIndemnity") }}</li>
            <!-- 预计赔款金额 -->
            <li>{{ $t("message.theEstimatedAmountOfCompensation") }}</li>
          </ol>
          <ul v-for="(item, index) in optionsList" :key="index">
            <!--附加服务选择  -->
            <li class="flex15">
              <div class="checkbox" v-if="item.edit">
                ({{ index + 1 }}) {{ item.name }}
              </div>
              <div class="checkbox" v-else>
                <el-checkbox v-model="item.checked"></el-checkbox>
                <div class="input">
                  <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                </div>
              </div>
            </li>
            <!--数量  -->
            <li>
              <el-input v-model="item.num" size="small" disabled></el-input>
            </li>
            <!--实际收费标准  -->
            <li class="flex15">
              <div class="template">
                <div class="input">
                  <el-input v-model="item.price" size="small" disabled></el-input>
                </div>
                {{ item.unit }}
              </div>
            </li>
            <!--预计费用  -->
            <li>
              <span class="total">
                <!-- 计算方式 当个 -->
                <span v-if="item.price_type == 0">
                  {{ item.checked ? (item.price * item.num).toFixed(2) : 0 }}
                </span>
                <!-- 计算方式 % -->
                <span v-else-if="item.price_type == 1 && item.checked">
                  {{ ((itemData.confirm_price * item.price * item.num) / 100).toFixed(2) }}
                </span>
              </span>
            </li>
            <!-- 赔款数量 -->
            <li>
              <el-input v-model="item.refund_num" onfocus="this.select()"></el-input>
            </li>
            <!-- 预计赔款金额 -->
            <li>
              <span class="total">
                <!-- 计算方式 当个 -->
                <span v-if="item.price_type == 0">
                  {{ item.refund_num ? (item.price * item.refund_num).toFixed(2) : 0 }}
                </span>
                <!-- 计算方式 % -->
                <span v-else-if="item.price_type == 1">
                  {{ item.refund_num ? ((itemData.confirm_price * item.price * item.refund_num) / 100).toFixed(2) : 0 }}
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    itemData: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,

      optionsList: [],

    };
  },
  methods: {
    // 编辑完成
    save() {

      this.optionsList = this.optionsList.filter(item => item.refund_num)
      this.$parent.redactOptionSuccess(this.optionsList);
      this.dialogVisible = false;
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {

        let datas = {
          user_id: this.itemData.order_sn.split('-')[1],
          order_detail_id: this.itemData.order_detail_id,
        }
        this.$api.siteConfiguration.optionList(datas).then((res) => {

          if (this.itemData.amountOption.amount_option_detail != false && this.itemData.amountOption.amount_option_detail != null) {
            this.itemData.amountOption.amount_option_detail.forEach((item) => {
              let flag = res.data.every((items) => item.id != items.id);
              if (flag) {
                this.res.data.push(item);
              }
              res.data.forEach((items) => {
                if (item.id == items.id) {
                  items.refund_num = item.refund_num;
                  items.checked = item.checked;
                  items.price = item.price;
                }
              });
            });
          }

          this.optionsList = res.data;
        });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}
</style>